import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";
import { generateRandomId } from "@/utils/generateRandomId";

import { getAutomationDataAttr } from "../../utils/automationUtils";
import { Image } from "../Image";
import { Popover } from "../Popover";
import { Portal } from "../Portal";
import { testLocator } from "../../lib/helpers/test-locator";

import "./styles.scss";

export const Info = ({ children, className, position, testId, ...props }) => {
  let toolTipId = generateRandomId() + "-tooltip";

  if (testId && process.env.REACT_APP_ENV !== "production") {
    toolTipId = testId;
  }

  const { "data-testid": dataTestId, ...containerProps } = props;

  return (
    <div className={createClassNameString(["apti-Info", position, className])} {...containerProps}>
      <Image
        alt="info"
        data-for={toolTipId}
        data-tip="info-tooltip"
        src="icons/info_button.svg"
        {...getAutomationDataAttr(testId)}
        {...testLocator(dataTestId)}
      />
      <Portal>
        <Popover className="apti-Info--popover" position={position} toolTipId={toolTipId}>
          {children}
        </Popover>
      </Portal>
    </div>
  );
};

Info.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  position: PropTypes.oneOf(["left", "right", "top", "bottom"]),
  testId: PropTypes.string,
};

Info.defaultProps = {
  children: <></>,
  className: undefined,
  position: "left",
  testId: undefined,
};
